import { createEvent, createStore, sample } from 'effector';
import { devicesEntity } from '@entities/devices';

const $isRecording = createStore(false);

const startRecording = createEvent();
const stopRecording = createEvent();
const resetRecording = createEvent();

$isRecording
  .on(startRecording, () => true)
  .on([stopRecording, resetRecording], () => false)

sample({
  clock: resetRecording,
  target: devicesEntity.clearData,
});

sample({
  clock: startRecording,
  fn: () => true,
  target: devicesEntity.$recordingStarted,
});

sample({
  clock: stopRecording,
  fn: () => false,
  target: devicesEntity.$recordingStarted,
})

export const sensorRecordingModel = {
  startRecording,
  resetRecording,
  stopRecording,
  $isRecording
}